export const StatusValues = {
  NOT_STARTED: 1,
  ON_HOLD: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
  TRANSFER_DELIVERY: 5,
};

export const stepType = {
  SEPARATION: 1, // Separação
  INTERCHANGE: 2, // Entrega ao transporte em andamento
  SHIPMENT: 3, // Embarque
  TRANSFER: 4, // Transferência
  CARRIER_IN_ROUTE: 5, // Transporte (rota)
  DELIVERED: 6, // Entregue

  WMS_NOT_HIRED: 7, // WMS não contratado
  TMS_NOT_HIRED: 8, // TMS não contratado
  CANCELED: 9, // Pedido cancelado
};

export const stepTypeTransKey = {
  [stepType.SEPARATION]: 'Separação',
  [stepType.INTERCHANGE]: 'Entrega ao transporte em andamento',
  [stepType.SHIPMENT]: 'Embarque',
  [stepType.TRANSFER]: 'Transferência',
  [stepType.CARRIER_IN_ROUTE]: 'Rota de entrega',
  [stepType.DELIVERED]: 'Entregue',

  [stepType.WMS_NOT_HIRED]: 'WMS não contratado',
  [stepType.TMS_NOT_HIRED]: 'TMS não contratado',
  [stepType.CANCELED]: 'Cancelado',
};
